import React, { useEffect, useState } from 'react';
import { checkIsLoginIn, userLoginApi } from '../../Services/auth';
import { useNavigate } from 'react-router-dom';
import Loading from '../../components/form/Loading';
import { useDispatch } from 'react-redux';
import { SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED } from '../../store/features/loadingSlice';
import { Controller, useForm } from 'react-hook-form';
import { http } from '../../utils/http';
import { useCookies } from 'react-cookie';
import { jwtDecode } from 'jwt-decode';
import { USER_PERMISSIONS } from '../../store/features/authSlice';

const COOKIE_EXPIRE_DAYS = Number(process.env.REACT_APP_COOKIE_EXPIRE_DAYS);

function Login() {
  const { handleSubmit, control, formState, reset } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [cookies, setCookie] = useCookies(['jwtToken']);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogin = async (data) => {
    dispatch(SET_IS_API_CALLED('Logging In'));
    const res = await http.post('/Auth/login', data);
    if (res) {
      const { token, expiredDate } = res?.data;

      const cookieExpiryDate = new Date();
      cookieExpiryDate.setDate(cookieExpiryDate.getDate() + COOKIE_EXPIRE_DAYS);
      setCookie('jwtToken', token, { path: '/', expires: cookieExpiryDate });
      const decodeCookie = jwtDecode(token);

      localStorage.setItem(
        'userData',
        JSON.stringify({
          id: decodeCookie['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
          email: decodeCookie['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'],
          role: decodeCookie['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'],
          userFullName: decodeCookie['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'],
          roleId: decodeCookie['RoleId'],
        })
      );

      // these permissions will determine whether user can view or write to data
      dispatch(
        USER_PERMISSIONS({
          CanDelete: decodeCookie['CanDelete'],
          CanRead: decodeCookie['CanRead'],
          CanView: decodeCookie['CanView'],
          CanWrite: decodeCookie['CanWrite'],
        })
      );
      if (res?.status === 200) {
        navigate('/');
      }
    }
    dispatch(SET_IS_API_CALLED_FINISHED());
  };
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };
  return (
    <>
      <form onSubmit={handleSubmit(handleLogin)}>
        <div className="flex h-screen items-center justify-center bg-light-blue-100">
          <div className="grid h-[574px] w-[970px] grid-cols-8 rounded-md bg-white shadow-md">
            <div className="col-span-4 flex items-center justify-center">
              <img src="assets/airselangor-logo.svg" className="h-[105] w-[385px]" alt="" />
            </div>
            <div className="col-span-4 w-full p-16">
              <div className="mb-4 text-center text-[25px] font-bold leading-normal text-medium-blue">
                <img src={'/assets/HYDROSMART Icon-02.png'} alt="Logo" className="w-full" />
              </div>
              <div className="relative mb-4 mt-10">
                <label htmlFor="email" className="block text-sm font-normal text-medium-grey-100">
                  Login ID
                </label>
                <Controller
                  name={`email`}
                  control={control}
                  rules={{
                    required: 'Email is required',
                    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  }}
                  render={({ field }) => (
                    <>
                      <input
                        type="email"
                        value={field.value}
                        onChange={field.onChange}
                        className="mt-1 block w-full rounded border-b px-3 py-2 font-normal outline-none placeholder:text-lg placeholder:text-black focus:ring focus:ring-indigo-300"
                        placeholder="abc@example.com"
                        required
                      />
                      <p className="mt-2 text-xs text-red-500">
                        {formState?.errors?.password?.message || ' '}
                        {formState?.errors?.password?.type === 'pattern' ? 'Wrong Pattern' : ' '}
                      </p>
                    </>
                  )}
                />
                <button
                  className="absolute right-3 top-8 focus:outline-none"
                  onClick={handleTogglePassword}
                >
                  <span>
                    {<img src="/assets/icon-lock.svg" className="h-[22px] w-[25px]" alt="" />}
                  </span>
                </button>
              </div>
              <div className="relative mb-4">
                <label
                  htmlFor="password"
                  className="block text-sm font-normal text-medium-grey-100"
                  defaultValue={'12345'}
                >
                  Password
                </label>
                <Controller
                  name={`password`}
                  control={control}
                  render={({ field }) => (
                    <>
                      <input
                        type={showPassword ? 'text' : 'password'}
                        value={field.value}
                        onChange={field.onChange}
                        className="mt-1 block w-full rounded border-b px-3 py-2 font-normal outline-none placeholder:text-lg placeholder:text-black focus:ring focus:ring-indigo-300"
                        placeholder="*******"
                        required
                      />
                      <p className="mt-2 text-xs text-red-500">
                        {formState?.errors?.password?.message || ' '}
                        {formState?.errors?.password?.type === 'pattern' ? 'Wrong Pattern' : ' '}
                      </p>
                    </>
                  )}
                />
                <button
                  className="absolute right-3 top-8 focus:outline-none"
                  onClick={() => handleTogglePassword()}
                  type="button"
                >
                  <span>
                    {showPassword ? (
                      <img src="/assets/icon-password.svg" className="h-[22px] w-[25px]" alt="" />
                    ) : (
                      <img src="/assets/icon-password.svg" className="h-[22px] w-[25px]" alt="" />
                    )}
                  </span>
                </button>
              </div>

              <div className="mb-6">
                <button
                  className="h-[50px] w-full bg-dark-blue-100 text-lg font-bold text-white hover:bg-blue-600"
                  type="submit"
                >
                  Log in
                </button>
              </div>
              <div
                onClick={() => navigate('/forgot-password')}
                className="cursor-pointer text-center text-sm text-medium-grey-100"
              >
                <span>Forgot your password?</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default Login;
